import { loadImage } from './loadImage';

async function formBase64Image(
  element: Element | null,
  format: string = 'png'
) {
  if (element === null)
    throw new Error('[saveElement] [formBase64Image] Element is null');

  const img = await loadImage(
    `data:image/svg+xml;base64,${btoa(element.outerHTML)}`
  );

  const canvas = document.createElement('canvas');

  /**
   * Set the dimensions of the canvas
   * We can infinitely scale because the original image is an SVG
   */
  canvas.width = img.width * 2;
  canvas.height = img.height * 2;
  const ctx = canvas.getContext('2d')!;

  // Draw the image to the canvas at full resolution
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  const imageUrl = canvas.toDataURL(`image/${format}`, 1.0);
  return imageUrl;
}

export async function saveSVGElement(
  querySelector: string,
  rootElement: Element
) {
  const element = rootElement.querySelector(querySelector);
  if (!element) {
    throw new Error(
      `[saveElement] Element (querySelector="${querySelector}") was not found`
    );
  }
  if (element.tagName.toUpperCase() !== 'SVG') {
    throw new Error(
      `[saveElement] Expected to be processing an SVG element. Got ${element.tagName}`
    );
  }

  return await formBase64Image(element);
}
